import { InflowOutflowByMonthResponse } from 'services/requests';
import {
  columns,
  EtzInflowOutflowTableSign,
  MapData,
} from 'screens/EtzProfile/EtzProfileInflowOutflowTable/EtzProfileInflowOutflowTable.columns';
import Table from 'components/Table';
import { AVALIABLE_ROWS_PER_PAGE } from 'components/Table/Table.constants';
import TableFooter from 'components/Table/TableFooter';

type RenderEtzProfileInflowOutflowTableProps = {
  inflowOutflowByMonthData?: InflowOutflowByMonthResponse;
  items?: MapData;
};

const RenderEtzProfileInflowOutflowTable = ({
  inflowOutflowByMonthData,
  items,
}: RenderEtzProfileInflowOutflowTableProps): JSX.Element | null => {
  if (!inflowOutflowByMonthData?.context || !items || (items && items?.length === 0))
    return null;

  return (
    <Table<EtzInflowOutflowTableSign> columns={columns} data={items}>
      <TableFooter
        pages={inflowOutflowByMonthData.context.pages}
        totalRows={inflowOutflowByMonthData.context.totalRows}
        availableRowsPerPage={AVALIABLE_ROWS_PER_PAGE}
      />
    </Table>
  );
};

export default RenderEtzProfileInflowOutflowTable;
